<template>
  <div class="container mt-5">
    <div v-if="!loading">
      <div class="d-flex justify-content-md-between flex-column align-items-center flex-md-row">
        <div v-if="listServicesCustom.length" class="d-flex flex-column flex-md-row bg-dark-primary rounded p-2">
          <div v-for="(item, index) in listServicesCustom" :key="index" @click="selectService(item)"
            class="rounded pointer text-center mx-2 px-4 py-1" :class="{ 'bg-primary': serviceName == item.name }">
            <h5 class="font-weight-bold mb-0" :class="{ 'bg-primary text-white': serviceName == item.name }">{{ item.name
            }}
            </h5>
          </div>
        </div>
        <div v-if="listServicesCustom.length" class="select-services mt-4 mt-md-0">
          <v-select @option:selected="selectedServicesType" v-model="servicesTypeName" dir="rtl" :options="servicesType">
          </v-select>
        </div>
        <div @click="$router.push('/admin/services')" class="admin pointer">
          <img src="@/assets/img/people.svg">
        </div>
      </div>
      <div class="mt-4 mt-md-5">
        <div v-if="plansList.length" class="row">
          <div v-for="(plan, index) in plansList" :key="`plan${index}`" class="col-md-4">
            <div class="original-card bg-white text-center mb-4 p-3">
              <div class=" text-success font-weight-bold py-1 px-4">
                <span class="bg-green-1 py-1 px-4 rounded-pill">{{ plan.category }}</span>
              </div>
              <h5 class="text-primary font-weight-bold mt-2">{{ plan.name }}</h5>
              <div class="original-card p-4 mt-4"
                :class="plan.is_bold ? 'bg-primary text-white' : 'bg-light-primary text-secondary'">
                <h4 class="font-weight-bold font-family-iranyekan mb-0">
                  از {{ plan.price.toLocaleString("fa-IR") }} تومان
                </h4>
              </div>
              <div class="my-4 px-3">
                <div v-for="(field, index) in plan.fields" :key="`field${index}`" class="mb-4">
                  <h5 v-if="field.name" class="text-right font-weight-bold text-secondary">{{ field.name }}</h5>
                  <div class="d-flex align-items-center">
                    <div class="bg-white rounded p-1">
                      <div style="width: 16px;">
                        <img :src="`${baseURL}/storage/${field.icon}`" class="w-100 h-100">
                      </div>
                    </div>
                    <h5 class="text-justify mb-0 mr-2">{{ field.description }}</h5>
                  </div>
                </div>
              </div>
              <div
                @click="$router.push({ name: 'options', query: { serviceId: plan.service.id, selectedPlans: plan.name, packageAmount: plan.price } })"
                class="original-card p-2 mt-4 pointer"
                :class="plan.is_bold ? 'bg-primary text-white' : 'bg-light-primary text-secondary'">
                <h4 class="font-weight-bold mb-0">انتخاب</h4>
              </div>
              <h6 class="pointer mt-3 mb-0">جزئیات بیشتر</h6>
            </div>
          </div>
        </div>
        <div v-if="!plansList.length" class="text-center h5 mt-5 pt-5">موردی وجود ندارد</div>
      </div>
    </div>
    <loading v-if="loading" :minHeight="80" />
  </div>
</template>


<script>
import loading from '@/components/loading.vue'
export default {
  name: 'Category',
  components: {
    loading
  },
  emits: ['active-categories'],
  data() {
    return {
      loading: false,
      baseURL: process.env.VUE_APP_BASE_URL,
      typePlan: null,
      servicesTypeName: null,
      servicesType: [],
      serviceName: null,
      filters: {
        pageIndex: 1,
        pageSize: 10,
        totalCount: null,
      },
      listServices: [],
      listServicesCustom: [],
      serviceId: 0,
      plansList: [],
    }
  },
  methods: {
    selectService(item) {
      this.servicesType = item.type;
      this.serviceName = item.name;
      this.servicesTypeName = item.type[0];
      this.serviceId = this.listServices.find(obj => obj.name === this.serviceName && obj.type === this.servicesTypeName)?.id;
      this.getPlansList()
    },
    async getServicesList() {
      this.loading = true;
      await this.axios.get(`services?page=${this.filters.pageIndex}&pageSize=${this.filters.pageSize}`).then(({ data }) => {
        this.filters.totalCount = data.totalCount;
        this.listServices = data.data;
        // unique names
        let uniqueNames = {};
        this.listServices.forEach(obj => {
          if (uniqueNames[obj.name]) {
            uniqueNames[obj.name].push(obj.type);
          } else {
            uniqueNames[obj.name] = [obj.type];
          }
        });
        this.listServicesCustom = Object.entries(uniqueNames).map(([name, type]) => ({ name, type }));
        // unique names
        this.serviceName = this.listServicesCustom[0].name
        this.servicesType = this.listServicesCustom[0].type
        this.servicesTypeName = this.listServicesCustom[0].type[0]
        this.serviceId = this.listServices.find(obj => obj.name === this.serviceName && obj.type === this.servicesTypeName)?.id;
        this.loading = false;
        this.getPlansList()
      }).catch((error) => {
        this.loading = false;
      })
    },
    selectedServicesType() {
      this.serviceId = this.listServices.find(obj => obj.name === this.serviceName && obj.type === this.servicesTypeName)?.id;
      this.getPlansList()
    },
    async getPlansList() {
      await this.axios.get(`service/${this.serviceId}/plans?page=1&pageSize=30`).then(({ data }) => {
        this.plansList = data.data
      }).catch((error) => {

      })
    },
  },
  mounted() {
    this.getServicesList();
  },
}
</script>


<style lang="scss">
.admin {
  @media only screen and (max-width: 767px) {
    display: none !important;
  }
}

.vs__actions {
  padding-top: 3px !important;
}

.vs__clear {
  display: none !important;
}

.select-services {
  width: 25%;

  @media only screen and (max-width: 767px) {
    width: 100% !important;
  }
}
</style>